import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {downloadPlantActions} from '../../common/backend/actions'
import {FEATURE_NAMESPACE} from '../../consts'

export const usePlantActionsDownload = (plantId: string) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation({
    mutationFn: () => downloadPlantActions(plantId),
    onSuccess: (blob: Blob) => {
      downloadFile(blob, `${plantId}_actions.xlsx`)
    },
    onError: () => {
      spawnErrorToast(t('errors.excelDownloadFailed'))
    }
  })
}
